/**
 * Krypto wird **nach** dem ersten Paint geladen (ARCHITECTURE.md §6).
 *
 * Die MLS-Bibliothek ist rund 675 kB entpackt — im Startbudget von 90 kB hätte
 * sie nichts verloren. Familienübersicht, Status und SOS müssen ohne sie
 * funktionieren; erst wer den Chat öffnet, wartet einmal auf das Nachladen.
 *
 * Der dynamische Import ist die einzige Stelle, an der `@fh/crypto` und
 * `./e2ee.js` betreten werden. Wer sie irgendwo statisch importiert, zieht die
 * Bibliothek ins Startbundle und reißt das Budget — der CI-Check schlägt dann an.
 */

import type * as E2EEModul from './e2ee.js'

type E2EE = typeof E2EEModul

let geladen: Promise<E2EE> | null = null

export function e2ee(): Promise<E2EE> {
  geladen ??= import('./e2ee.js')
  return geladen
}

/** Ob die Bibliothek schon im Speicher ist — für „wird geladen…"-Anzeigen. */
export function istGeladen(): boolean {
  return geladen !== null
}

/**
 * Startet das Nachladen im Hintergrund, ohne darauf zu warten.
 * Wird aufgerufen, sobald die Startseite steht — dann ist die Bibliothek meist
 * schon da, bevor jemand auf „Chat" tippt.
 */
export function vorwaermen(): void {
  if (geladen) return
  const start = () => { void e2ee() }
  if ('requestIdleCallback' in globalThis) {
    ;(globalThis as { requestIdleCallback: (cb: () => void) => void }).requestIdleCallback(start)
  } else {
    setTimeout(start, 1500)
  }
}
